<style>
    /* --- Base para todos los Badges de Estado --- */
    .badge-status {
        /* Asegura que el contenedor sea flex para centrar contenido */
        display: inline-flex; 
        align-items: center; /* Centrado vertical */
        justify-content: center; /* Centrado horizontal */
        width: 32px; /* Ligeramente más grande para mejor visibilidad del ícono */
        height: 32px;
        border-radius: 50%; /* Asegura que sea un círculo perfecto */
        overflow: hidden; /* Corta cualquier contenido que se desborde */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
        transition: all 0.3s ease-in-out; 
        cursor: pointer; 
    }

    /* --- Estilos para los Íconos (dentro del Badge) --- */
    .badge-status i {
        font-size: 16px; /* Tamaño del ícono, ajusta según necesidad */
        color: #FFFFFF; /* Color blanco para el ícono para alto contraste */
        /* Ligera sombra de texto para que el ícono resalte (opcional) */
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); 
    }

    /* --- Colores Específicos para cada Estado (adapta a tus colores de tema) --- */

    /* Estado 'Aprobado' (Success) */
    .badge-success {
        background-color: #28a745; /* Bootstrap Green */
        /* Puedes añadir un gradiente para un efecto más "pro" */
        background-image: linear-gradient(135deg, #28a745 0%, #218838 100%);
        border: 1px solid #218838; /* Borde sutil para definirlo */
    }

    /* Estado 'Detenido/Rechazado' (Danger) */
    .badge-danger {
        background-color: #dc3545; /* Bootstrap Red */
        background-image: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
        border: 1px solid #c82333;
    }

    /* Estado 'Advertencia/Pendiente' (Warning) */
    .badge-warning {
        background-color: #ffc107; /* Bootstrap Yellow */
        background-image: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
        border: 1px solid #e0a800;
    }

    /* Estado 'Neutro/Desconocido' (Secondary) */
    .badge-secondary {
        background-color: #6c757d; /* Bootstrap Grey */
        background-image: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
        border: 1px solid #5a6268;
    }

    .professional-badge {
        display: inline-flex; /* Permite centrar contenido y control de tamaño */
        align-items: center;  /* Centrado vertical del texto */
        justify-content: center; /* Centrado horizontal del texto */
        
        padding: 0.4em 0.8em; /* Relleno superior/inferior y lateral */
        border-radius: 0.35rem; /* Bordes ligeramente redondeados (puedes usar 50% para píldora) */
        font-size: 0.85em; /* Tamaño de fuente ligeramente más pequeño */
        font-weight: 600; /* Texto más audaz */
        text-transform: uppercase; /* Texto en mayúsculas para un aspecto más limpio */
        letter-spacing: 0.05em; /* Espaciado entre letras para mejor legibilidad */
        white-space: nowrap; /* Evita que el texto se rompa en varias líneas */
        
        color: #FFFFFF; /* Color de texto blanco por defecto para alto contraste */
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15); /* Sombra suave para profundidad */
        transition: all 0.2s ease-out; /* Transiciones suaves para cambios de estado */
        cursor: pointer; 
    }

    /* Badge para 'Active' (Verde - Success) */
    .professional-badge-success-badge {
        background-color: #28a745; /* Color base Bootstrap Green */
        background-image: linear-gradient(45deg, #28a745 0%, #218838 100%); /* Gradiente sutil */
        border: 1px solid #218838; /* Borde que coincide con el color del gradiente */
    }

    /* Badge para 'Cancelled' (Rojo - Danger) */
    .professional-badge-danger-badge {
        background-color: #dc3545; /* Color base Bootstrap Red */
        background-image: linear-gradient(45deg, #dc3545 0%, #c82333 100%); /* Gradiente sutil */
        border: 1px solid #c82333;
    }

    /* Badge por defecto/información (Azul/Gris - Info/Secondary) */
    .professional-badge-info-badge {
        background-color: #17a2b8; /* Color base Bootstrap Info (azul) */
        background-image: linear-gradient(45deg, #17a2b8 0%, #138496 100%); /* Gradiente sutil */
        border: 1px solid #138496;
        /* Si prefieres un gris neutro para 'info', puedes usar: */
    }

    /* Opcional: Estilos al pasar el ratón (hover) para interactividad */
    .professional-badge:hover {
        transform: translateY(-1px); /* Ligero levantamiento */
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Sombra más pronunciada */
    }

    .professional-badge-warning-badge {
        background-color: #ffc107;
        background-image: linear-gradient(45deg, #ffc107 0%, #e0a800 100%);
        border: 1px solid #e0a800;
        color: #212529; /* texto oscuro porque el amarillo es claro */
    }
</style>
<template>
    <!-- componente de jerson -->
    <div class="content-wrapper" v-if="!redirected">
        <div class="row" v-if="showForm == false">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('contract_title')" :directory="$t('list')" :icon="'grid'" />
            </div>
            <div v-if="!is_logistic_coordinator" class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-success btn-with-shadow" @click="exportAll">
                        {{ $t('export_all') }}
                    </button>
                    <button type="button" class="btn btn-primary btn-with-shadow" @click="addContract">
                        {{ $t('add') }}
                    </button>
                </div>
            </div>
        </div>

        <div v-if="LoadCustomFilter">
            <app-table v-if="showForm == false" :id="tableId" :options="options" @action="getListAction"
            :selected-url="selectedUrl" />
        </div>
        

       <product-add-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" /> 

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="demo-delete"
            @confirmed="confirmed" @cancelled="cancelled" />

        <app-add-sub_contract v-if="add_sub_contract" modal-id="add-sub_contract" :contractId="contractId"
            @confirmed_subcontract="confirmed_subcontract" @cancelled_subcontract="cancelled_subcontract" />

        <duplicate_contract v-if="duplicate_contract" modal-id="duplicate_contract" :contractId="contractId"
            @confirmed_duplicate="confirmed_duplicate" @cancelled_duplicate="cancelled_duplicate" @update-contract-number="handleContractNumberUpdate"  />    
    </div>
</template>

<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../Config/ApiUrl.js";
import { CONTRACTS_EXPORT, CONTRACTS_ADD } from "../../../Config/ApiUrl.js";
import { urlGenerator } from "../../../Helpers/AxiosHelper.js";
import { TableHelpers } from './mixins/TableHelpers.js';
import {get_data_customTable} from './mixins/api.js';

export default {
    extends: CoreLibrary,
    name: "contractList",
    mixins: [TableHelpers],
    data() {
        return {
            is_logistic_coordinator : false,
            preloader : false,
            contract_number_new : 0,
            CONTRACTS_EXPORT,
            redirected : false,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            add_sub_contract : false,
            duplicate_contract : false,
            contractId : null,
            showForm: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'advance-table',
            rowData: {},
            customFilters : [],
            LoadCustomFilter : false,
            options: {
                name: 'AdvanceTable',
                url: actions.CONTRACTS_DATA,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: this.get_actions(),
                filters: this.customFilters,
                showFilter: true,
                showSearch: true,
                showCount: false,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },


    created() {
        this.options.columns = [...this.tableColumns, this.actionObj];
        // this.searchAndSelectFilterOptions();
    },
    beforeRouteLeave(to, from, next) {
        // Esto asegura que el componente se desmonte cuando se navega a otra ruta
        next();
    },
    async mounted(){
        if (localStorage.getItem('process_edit_contract') || localStorage.getItem('process_view_contract')) {
            this.clearStorage();
        }
        try {
            const loadedFilters = await this.getFiltersOpt();
            this.customFilters = loadedFilters;
            this.options = {
                ...this.options,
                filters: this.customFilters,
                actions: this.get_actions() 
            };
            this.$nextTick(() => {
                this.LoadCustomFilter = true;
            });
        } catch (error) {
            console.log(error);
        }
    },

    methods: {
        async getFiltersOpt(){
            const response = [];
            const optShipmentType = await this.get_shipment_opt_filter();
            
            const optSupplier = await this.get_suppliers_opt_filter();
            const optCustomer = await this.get_customers_opt_filter();
            const optLogisticCoordinator = await this.get_coordinator_opt_filter();
            const optProducts = await this.get_products_opt_filter();
            const optDateCreate = this.get_creation_date_opt_filter();
            const optStatus = this.get_status_opt_filter();
            const optCountryOrigin = await this.get_country_opt_filter();
            const optApproved = this.get_approved_opt_filter();
            
            response.push(optDateCreate);
            response.push(optShipmentType);
            response.push(optCountryOrigin);
            response.push(optSupplier);
            response.push(optCustomer);
            response.push(optProducts);
            response.push(optLogisticCoordinator);
            response.push(optApproved);
            response.push(optStatus);

            return response;
        },

        get_approved_opt_filter(){
            return {
                "title": "Approved & ready for Logistics",
                "type": "checkbox",
                "key": "approved",
                "option": [
                    {
                        id: 0,
                        name: "Not Approved"
                    },
                    {
                        id: 2,
                        name: "Pending Approval"
                    },
                    {
                        id: 1,
                        name: "Approved"
                    },
                ],
                listValueField: 'name'
            }
        },

        get_status_opt_filter(){
            return {
                "title": "Status",
                "type": "checkbox",
                "key": "status",
                "option": [
                    {
                        id: 1,
                        name: "active"
                    },
                    {
                        id: 2,
                        name: "cancelled"
                    },
                    {
                        id: 3,
                        name: "finished"
                    },
                ],
                listValueField: 'name'
            }
        },

        get_creation_date_opt_filter(){
            return {
                    type: 'date', // can not be cleared!
                    key: 'created_date',
                }
        },

        async get_products_opt_filter(){
            return {
                title: "Product",
                type: "search-and-select-filter",
                key: "product_id",
                settings: {
                    url: `/product/get_products`, // this url will hit every search action
                    modifire: (v) => {
                        return { id: v.id, name: v.name }
                    },
                    per_page: 10, // default 10, you can change it any number. min 10 encourage to use
                    queryName: 'name', // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
                    loader: 'app-pre-loader', // default app-overlay-loder
                    multiple: false, // default false, if you need to select multiple item so make it true
                },
                listValueField: 'name'
            }; 
        },

        async get_country_opt_filter(){
            return {
                title: "Country of origin",
                type: "search-and-select-filter",
                key: "country_id",
                settings: {
                    url: `/countries/serverside/selectable-name`, // this url will hit every search action
                    modifire: (v) => {
                        return { id: v.id, name: v.name }
                    },
                    per_page: 10, // default 10, you can change it any number. min 10 encourage to use
                    queryName: 'search', // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
                    loader: 'app-pre-loader', // default app-overlay-loder
                    multiple: false, // default false, if you need to select multiple item so make it true
                },
                listValueField: 'name'
            }; 
        },

        async get_coordinator_opt_filter(){
            return {
                title: "Logistic Coordinator ",
                type: "search-and-select-filter",
                key: "logistic_coordinator_id",
                settings: {
                    url: `/users/serverside/logisticCoord/selectable-name`, // this url will hit every search action
                    modifire: (v) => {
                        return { id: v.id, name: v.full_name }
                    },
                    per_page: 10, // default 10, you can change it any number. min 10 encourage to use
                    queryName: 'full_name', // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
                    loader: 'app-pre-loader', // default app-overlay-loder
                    multiple: false, // default false, if you need to select multiple item so make it true
                },
                listValueField: 'name'
            }; 
        },

        async get_suppliers_opt_filter(){
            return {
                title: "Supplier",
                type: "search-and-select-filter",
                key: "supplier_id",
                settings: {
                    url: `/companies_supplier/get_suppliers`, // this url will hit every search action
                    modifire: (v) => {
                        return { id: v.id, name: v.Second_Title }
                    },
                    per_page: 10, // default 10, you can change it any number. min 10 encourage to use
                    queryName: 'Second_Title', // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
                    loader: 'app-pre-loader', // default app-overlay-loder
                    multiple: false, // default false, if you need to select multiple item so make it true
                },
                listValueField: 'name'
            }; 
        },

        async get_customers_opt_filter(){
            return{
                title: "Customer",
                type: "search-and-select-filter",
                key: "customer_id",
                settings: {
                    url: `/companies_customer/get_customers`, // this url will hit every search action
                    modifire: (v) => {
                        return { id: v.id, name: v.Second_Title }
                    },
                    per_page: 10, // default 10, you can change it any number. min 10 encourage to use
                    queryName: 'Second_Title', // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
                    loader: 'app-pre-loader', // default app-overlay-loder
                    multiple: false, // default false, if you need to select multiple item so make it true
                },
                listValueField: 'name'
            } 
        },

        async get_shipment_opt_filter(){
            const shipment_type = await get_data_customTable('shipment_type');
            const res = {
                "title": "Shipment Type",
                "type": "drop-down-filter",
                "key": "shipment_type",
                "option": shipment_type,
                listValueField: 'value'
            }
            return res;
        },
    
        get_actions(){
            let isLogisticCoordinator = false;
            const roles = user.roles;
            roles.forEach( rol => {
                if (rol.name === 'Logistics Coordinator') {
                    isLogisticCoordinator = true;
                }
            });
            if (isLogisticCoordinator) {
                return [
                    {
                        title: this.$t('view'),
                        icon: 'eye',
                        type: 'none',
                    },
                    {
                        title: this.$t('sub contract'),
                        icon: 'chevrons-right',
                        type: 'none',
                        component: 'app-confirmation-modal',
                    }
                ]
            }
            return [
                    {
                        title: this.$t('view'),
                        icon: 'eye',
                        type: 'none',
                    },
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'demo-delete',
                    },
                    {
                        title: this.$t('duplicate'),
                        icon: 'copy',
                        type: 'none',
                        component: 'app-confirmation-modal',
                    },
                    
                ]
        },

        /**
         * $emit Form datatable action
         */
        async getListAction(rowData, actionObj, active) {
            let isLogisticCoordinator = false;
            const roles = user.roles;
            roles.forEach( rol => {
                if (rol.name === 'Logistics Coordinator') {
                    isLogisticCoordinator = true;
                }
            });
            this.isLogisticCoordinator = isLogisticCoordinator;
            this.rowData = rowData;
            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                await this.clearStorage();
                const rowId = rowData.Id; // contract id 
                const data = {
                    country: {
                        id: rowData?.country?.id ?? null,
                        name: rowData?.country?.name ?? null,
                        Code: rowData?.country?.Code ?? null,
                    },
                    category: {
                        id: rowData?.category?.id ?? null,
                        name: rowData?.category?.name ?? null,
                        code: rowData?.category?.code ?? null
                    },
                    contractNumber: rowData?.number ?? null,
                }
                localStorage.setItem('DataContractMaster', JSON.stringify(data));
                localStorage.setItem('process_edit_contract', true);
                this.showForm = true;
                this.$router.push({
                    name: 'contract',
                    query: { 'tab': 'contract' },
                    params: { id: rowId }
                });
            } else if (actionObj.title == this.$t('view')) {
                await this.clearStorage();
                const rowId = rowData.Id; // contract id 
                const data = {
                    country: {
                        id: rowData?.country?.id ?? null,
                        name: rowData?.country?.name ?? null,
                        Code: rowData?.country?.Code ?? null,
                    },
                    category: {
                        id: rowData?.category?.id ?? null,
                        name: rowData?.category?.name ?? null,
                        code: rowData?.category?.code ?? null
                    },
                    contractNumber: rowData?.number ?? null,
                }
                localStorage.setItem('DataContractMaster', JSON.stringify(data));
                this.showForm = true;
                if (isLogisticCoordinator) {
                    this.$router.push({
                        name: 'contract-detail',
                        query: { 'tab': 'contract-detail' },
                        params: { id: rowId }
                    });
                }else{
                    localStorage.setItem('process_view_contract', true);
                    this.$router.push({
                        name: 'contract',
                        query: { 'tab': 'contract' },
                        params: { id: rowId }
                    });
                }
            } else if(actionObj.title == this.$t('sub contract')){
                const rowId = rowData.Id; 
                this.openAddSubContract(rowId);
            } else if(actionObj.title == this.$t('duplicate')){
                const rowId = rowData.Id; 
                this.openDuplicateContract(rowId);
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        openAddSubContract(rowId){
            this.contractId = rowId;
            this.add_sub_contract = true;
        },

        openDuplicateContract(rowId){
            this.contractId = rowId;
            this.duplicate_contract = true;
        },

        confirmed() {
            let url = `${actions.PRODUCTS_DATA}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    this.searchAndSelectFilterOptions();
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        async confirmed_subcontract() { 
            this.add_sub_contract = false; // Oculta el modal  
            this.preloader = true;
            try {
                const dataR = { contractId : this.contractId }
                const response = await axios.post("/api/subcontract/create_subcontract", dataR);

                const {data} = response;
                if (data.status === 0) {
                    this.$toastr.e(data.message);
                    return;
                }
                this.$toastr.s(response.data.message);
                window.location.href = data.redirect;
            } catch (error) {
                let msg = "Error saving data";
				if (error.response.data?.error) {
				    msg = error.response.data.error;
				}
				this.$toastr.e(msg);
            }
        },
        
        async confirmed_duplicate() { 
            this.duplicate_contract = false; // Oculta el modal  
            await this.submit_duplicate();
        },

        async submit_duplicate(){
            this.preloader = true;
            const data = {
                contract_id : this.contractId,
                contract_number_new : this.contract_number_new
            }
            const response = await axios.post("/api/contracts/duplicate_contract", data);
            this.$toastr.s(response.data.message);
            this.preloader = false;
            const base_url = localStorage.getItem("base_url");
            window.location.href = `${base_url}/contracts/list`;
        },
        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },

        cancelled_subcontract() {
            this.add_sub_contract = false;
            this.reSetData();
        },
        
        cancelled_duplicate() {
            this.duplicate_contract = false;
            this.reSetData();
        },
        
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
        searchAndSelectFilterOptions() {
            this.axiosGet(actions.CONTRACTS_SERVER_SEARCH_SELECT).then(response => {
                let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));        
                if (response.data) {       
                    name.option = response.data.data.map(item => {
                        return {
                            id: item.number,
                            value: item.number
                        }
                    });
                }
            });
        },

        
        exportAll() {
            window.location.replace(urlGenerator(CONTRACTS_EXPORT))
        },

        addContract(){
            localStorage.removeItem('process_view_contract');
            window.location.replace(urlGenerator(CONTRACTS_ADD))
        },

        async clearStorage () {
            localStorage.removeItem("DataContractDetail");
            localStorage.removeItem("DataContractMaster");
            localStorage.removeItem("DataProductDetail");
            localStorage.removeItem("DataSupplierDetail");
            localStorage.removeItem("DataCustomerDetail");
            localStorage.removeItem("categorySelected");
            localStorage.removeItem("contractNumber");
            localStorage.removeItem("countrySelected");
            localStorage.removeItem("selectedProducts");
            localStorage.removeItem("process_add_contract");

            localStorage.removeItem('DataContractDetail_edit');
            localStorage.removeItem('DataProductDetail_edit');
            localStorage.removeItem('selectedProducts_edit');
            localStorage.removeItem('DataSupplierDetail_edit');
            localStorage.removeItem('DataCustomerDetail_edit');
            localStorage.removeItem('DataRevision_edit');

            localStorage.removeItem('DataContractDetail_view');
            localStorage.removeItem('DataProductDetail_view');
            localStorage.removeItem('selectedProducts_view');
            localStorage.removeItem('DataSupplierDetail_view');
            localStorage.removeItem('DataCustomerDetail_view');
            localStorage.removeItem('DataRevision_view');

            localStorage.removeItem("DataContractDetail");
            localStorage.removeItem("DataProductDetail");
            localStorage.removeItem("DataSupplierDetail");
            localStorage.removeItem("DataCustomerDetail");
            localStorage.removeItem("selectedProducts");

            localStorage.removeItem('process_view_contract');
            localStorage.removeItem('process_edit_contract');
            localStorage.removeItem('process_add_contract');
        },

        getContracts() {
            axios.get('/contracts')
                .then(response => {})
                .catch(error => {
                    console.error('Error fetching contracts:', error);
                });
        },

        redirectToSubcontractAdd(){
            this.showForm = true;
            this.$nextTick(()=>{
                this.$router.push({
                    name: 'products-sub',
                    query: { 'tab': 'products-sub' },
                    params: { id: this.contractId }
                });
            });
        },

        handleContractNumberUpdate(valor) {
            console.log("Nuevo contractNumber:", valor);
            this.contract_number_new = valor; // o lo que necesites hacer
        }
    },
}
</script>
